module.exports = __webpack_public_path__ + "static/media/volksbank-mobileWithLogo.0deb5d9d.png";